import Select from 'react-select';
import useSubjects from 'hooks/API/GET/useSubjects';
import { Fragment, useEffect, useState } from 'react';

function ESSubjectDropDownMultiple({
  enableAPI,
  value = [],
  handleChange,
  dependencies = {},
  fieldErrors = {},
}) {
  const { query = '' } = dependencies;
  const [availableSubject, setAvailableSubject] = useState([]);
  const [initialValue, setInitialValue] = useState([]);
  const queryParams = `?mode=dropdown${query ? `&${query}` : ``}`;
  const { data, isLoading, isError } = useSubjects({ enabled: enableAPI, queryParams });
  const { errorMessage = '' } = fieldErrors;

  useEffect(() => {
    const result = data?.data?.map?.((option) => ({ value: option._id, label: option.name }));
    setAvailableSubject(result);
  }, [data?.data]);

  useEffect(() => {
    setInitialValue(value);
  }, [value]);

  let selectBoxClasses = '';
  if (errorMessage) selectBoxClasses = 'border border-danger';

  function defaultValue(label) {
    return [{ value: label, label: label, isDisabled: true }];
  }

  const updateDataChange = (option = []) => handleChange(option);

  return (
    <Fragment>
      <label>Select Subjects</label>
      {isLoading ? (
        <Select options={defaultValue('Loading...')} className={selectBoxClasses} />
      ) : isError ? (
        <Select options={defaultValue('Failed to load list...')} className={selectBoxClasses} />
      ) : (
        <Fragment>
          {data?.data?.length > 0 ? (
            <Select
              isMulti
              value={initialValue}
              options={availableSubject}
              className={selectBoxClasses}
              onChange={updateDataChange}
            />
          ) : (
            <Select options={defaultValue('No options found...')} className={selectBoxClasses} />
          )}
        </Fragment>
      )}
    </Fragment>
  );
}

ESSubjectDropDownMultiple.defaultProps = {
  value: [],
  handleChange: () => {},
};

export default ESSubjectDropDownMultiple;
